import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import createTheme from "@mui/material/styles/createTheme";
import { StyleRoot } from "@redotech/react-util/style";
import {
  MODAL_REDO_OVERLAY_Z_INDEX,
  POPPER_REDO_OVERLAY_Z_INDEX,
} from "@redotech/redo-web/shopify/shopify-z-index";
import { memo, ReactNode } from "react";
import STYLE_MANAGER from "../style-manager";

export interface RedoStorefrontContainerProps {
  children: ReactNode;
  container: Element;
}

export const RedoStorefrontContainer = memo(function RedoStorefrontContainer({
  children,
  container,
}: RedoStorefrontContainerProps) {
  return (
    <StyleRoot container={container} styleManager={STYLE_MANAGER}>
      <MuiRoot container={container}>{children}</MuiRoot>
    </StyleRoot>
  );
});

export function MuiRoot({
  container,
  children,
}: {
  container: Element;
  children: ReactNode;
}) {
  const shadowRoot = container.shadowRoot;

  if (!shadowRoot) {
    return null;
  }

  const muiRoot = document.createElement("div");
  shadowRoot.append(muiRoot);

  muiRoot.style.setProperty(
    "--popper-z-index",
    `${POPPER_REDO_OVERLAY_Z_INDEX}`,
  );

  const muiTheme = createTheme({
    components: {
      MuiModal: {
        defaultProps: {
          container: muiRoot,
          style: {
            position: "fixed",
            inset: "0",
            zIndex: MODAL_REDO_OVERLAY_Z_INDEX,
          },
        },
      },
      MuiBackdrop: {
        defaultProps: { style: { position: "fixed", inset: "0", zIndex: -1 } },
      },
      MuiPopper: {
        defaultProps: { container: muiRoot },
        styleOverrides: { root: { zIndex: POPPER_REDO_OVERLAY_Z_INDEX } },
      },
    },
  });

  return <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>;
}
